import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalService } from "@azure/msal-angular";
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { PlexEnvironment } from 'environments/environment';
import { AssetTeamInterceptor } from "./shared/services/interceptor/http-interceptor-request-asset-team-service";

export const msalProviders = [
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory,
    deps: [PlexEnvironment],
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory,
    deps: [PlexEnvironment],
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory,
    deps: [PlexEnvironment],
  },
  { provide: HTTP_INTERCEPTORS, useClass: AssetTeamInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true
  },
  MsalService,
  MsalGuard,
  MsalBroadcastService,
];

export function MSALInstanceFactory(env: PlexEnvironment): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: env.msalConfig.auth.clientId,
      authority: env.msalConfig.auth.authority,
      redirectUri: '/',
      postLogoutRedirectUri: '/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  }
  );
}

export function MSALInterceptorConfigFactory(env: PlexEnvironment): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(env.apiConfig.uri, env.apiConfig.scopes);
  protectedResourceMap.set(`${env.apiUrl}*`, env.apiConfig.accessScopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(env: PlexEnvironment): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...env.apiConfig.scopes]
    },
    loginFailedRoute: '/access-denied'
  };
}

export function loggerCallback(logLevel: LogLevel, message: string) {
  if (logLevel == LogLevel.Warning || logLevel == LogLevel.Error) {
    console.log(`log msal: ${logLevel} ==> ${message}`);
  }
}

